export default {
  name: 'Identity Server',
  password: 'Contraseña',
  username: 'Usuario',
  user_not_found: 'Usuario no encontrado'
};